import React from 'react';
import FixedBottomNavBar from '../../../../components/FixedBottomNavBar';
import Button from '../../../../components/Button';
import { TAG_EDIT_URL_PATH } from '../../../../constants/service/common/urlConstants';
import { TAG_STATUS } from '../../../../constants/service/app/tagConstants';
import { reDirectPage, setDetailPageUrl } from '../../../../lib/common';
import './TagHistoryNavbar.scss';

const TagHistoryNavbar = (props) => {
  const { tagId, status, getTagPreviewData } = props;

  return (
    <FixedBottomNavBar className="tag-history-navbar">
      <div className="button-group">
        <div className="left">
          <Button color="light" text="미리보기" onClick={() => getTagPreviewData({ tagId })} />
        </div>

        <div className="right">
          <Button
            color="gray"
            text={status === TAG_STATUS.confirmReady ? '승인/거절' : '편집'}
            onClick={() =>
              reDirectPage({
                path: setDetailPageUrl(TAG_EDIT_URL_PATH, tagId),
              })
            }
          />
        </div>
      </div>
    </FixedBottomNavBar>
  );
};

export default TagHistoryNavbar;
